// import {
//   Button,
//   FormControl,
//   FormHelperText,
//   Grid,
//   MenuItem,
//   Select,
//   TextField,
// } from "@mui/material";
// import { useFormik } from "formik";
// import { useEffect, useState } from "react";
// import { Spinner } from "react-bootstrap";
// import { useNavigate, useParams } from "react-router-dom";
// import { toast } from "react-toastify";
// import * as Yup from "yup";
// import { createInfluncer, redeemAmt, redirectCoupon } from "../Apis";
// import { BZLogoHeader, successIcn } from "../Assets/Images";
// import { decryptData } from "../Components/Helpers/encryptDecrypt";
// import { validationHelper } from "../Components/Helpers/validationHelper";
// import VerifyInfluncer from "../Components/StyleComponent/Modals/VerifyInfluncer";
// import PageContainer from "../Components/StyleComponent/PageContainer";
// import SimpleCard from "../Components/StyleComponent/SimpleCard";
// import GetUserType from "../Contexts/GetUserType";

// const RedeemCash = () => {
//   const { id, permission_id } = useParams();
//   const [loader, setLoader] = useState(false);
//   const [otpModal, setOtpModal] = useState(false);
//   const [isOtpVerified, setIsOtpVerified] = useState(false);
//   const [success, setSuccess] = useState(false);
//   const [errMsg, setErrMsg] = useState("");

//   const type = GetUserType();

//   const validationSchema = Yup.object({
//     cash: validationHelper.commonText("Cash"),
  
//     mobile: validationHelper.commonText("Mobile"),
  
//     upi_id: Yup.string().when("transfer_mode", {
//       is: (transfer_mode: string) =>
//         isOtpVerified && transfer_mode === "upi",
//       then: () => validationHelper.commonText("UPI ID"),
//       otherwise: () => Yup.string(),
//     }),
  
//     account_number: Yup.string().when("transfer_mode", {
//       is: (transfer_mode: string) =>
//         isOtpVerified && transfer_mode === "imps",
//       then: () => validationHelper.commonText("Account Number"),
//       otherwise: () => Yup.string(),
//     }),
  
//     ifsc: Yup.string().when("transfer_mode", {
//       is: (transfer_mode: string) =>
//         isOtpVerified && transfer_mode === "imps",
//       then: () => validationHelper.commonText("IFSC Code"),
//       otherwise: () => Yup.string(),
//     }),
//   });
//   const formik = useFormik({
//     initialValues: {
//       cash: "",
//       mobile: "",
//       upi_id: "",
//       account_number: "",
//       ifsc: "",
//       transfer_mode: "imps",
//     },
//     validationSchema,
//     onSubmit: async (values) => {
//       if (!isOtpVerified) {
//         setLoader(true);
//         try {
//           const res: any = await createInfluncer({
//             mobile_number: values.mobile,
//           });
//           if (res.status) {
//             setOtpModal(true);
//           } else {
//             toast.error(res.message);
//           }
//         } catch (err: any) {
//           console.log(err);
//           toast.error(err.message);
//         } finally {
//           setLoader(false);
//         }
//         return;
//       }

//       setLoader(true);
//       let payload: any = values;

//       if (type === "employee") {
//         payload.permission_id = decryptData(permission_id);
//       }

//       payload.coupon_code = id;

//       for(let key in payload) {
//         if(payload[key] === "") {
//           delete payload[key];
//         }
//       }

//       try {
//         const res: any = await redeemAmt(payload);
//         if (res?.status) {
//           localStorage.removeItem("accessToken");
//           toast.success(res.message);
//           setSuccess(true);
//           //   navigate(-1);
//         } else {
//           toast.error(res.message);
//         }
//       } catch (err: any) {
//         toast.error(err.message);
//       } finally {
//         setLoader(false);
//       }
//     },
//   });

//   const {
//     values,
//     errors,
//     touched,
//     handleSubmit,
//     setFieldValue,
//     getFieldProps,
//   }: any = formik;

//   const getCoupon = async () => {
//     await redirectCoupon({ coupon_code: id })
//       .then((res: any) => {
//         if (res?.status) {
//           setFieldValue("cash", res?.data?.amount || "");
//         } else {
//           toast.error(res.message);
//           setErrMsg(res.message);
//         }
//       })
//       .catch((err) => {
//         toast.error(err.message);
//         setErrMsg(err.message);
//       });
//   };

//   useEffect(() => {
//     getCoupon();
//   }, []);

//   const handleMobileChange = (e: any) => {
//     if (e.target.value.length <= 10) {
//       setFieldValue("mobile", e.target.value);
//     }
//   };

//   const handleOtpSuccess = () => {
//     setOtpModal(false);
//     setIsOtpVerified(true);
//     toast.success("OTP verified successfully");
//   };

//   return (
//     <PageContainer>
//       <Grid container spacing={2} className="d-flex justify-content-around">
//         <Grid item lg={4} xs={12}>
//           <SimpleCard>
//             <div className="mb-3 ms-3 text-center">
//               <img src={BZLogoHeader} alt="logo" style={{ width: "150px" }} />
//             </div>

//             {success ? (
//               <div className="text-center mt-5 mb-5">
//                 <img src={successIcn} alt="logo" style={{ width: "150px" }} />
//                 <h4 className="mt-4 ms-2">Redeem Successful</h4>
//               </div>
//             ) : errMsg ? (
//               <div className="alert alert-danger text-center" role="alert">
//                 {errMsg}
//               </div>
//             ) : (
//               <form onSubmit={handleSubmit} className="ps-3 pe-3">
//                 <Grid container spacing={2}>
//                   {/* Cash */}
//                   <Grid item xs={12}>
//                     <TextField
//                       label="Cash"
//                       fullWidth
//                       disabled
//                       value={values.cash}
//                       error={Boolean(touched.cash && errors.cash)}
//                       helperText={touched.cash && errors.cash}
//                     />
//                   </Grid>

//                   {/* Mobile */}
//                   <Grid item xs={12}>
//                     <TextField
//                       label="Mobile Number"
//                       fullWidth
//                       disabled={isOtpVerified}
//                       value={values.mobile}
//                       onChange={handleMobileChange}
//                       error={Boolean(touched.mobile && errors.mobile)}
//                       helperText={touched.mobile && errors.mobile}
//                     />
//                   </Grid>

//                   {/* UPI (Only after OTP verified) */}

//                   {/* {isOtpVerified && (
//                     <Grid item sm={6} lg={12} xs={12}>
//                       <label
//                         className="input-label"
//                         style={{ marginBottom: "6px" }}
//                       >
//                         Transfer Mode<strong className="required">*</strong>
//                       </label>
//                       <FormControl
//                         fullWidth
//                         error={Boolean(
//                           errors.transfer_mode && touched.transfer_mode
//                         )}
//                       >
//                         <Select
//                           inputProps={{ "aria-label": "Without label" }}
//                           onChange={(e) => {
//                             setFieldValue("transfer_mode", e.target.value);
//                             setFieldValue("upi_id", "");
//                             setFieldValue("account_number", "");
//                             setFieldValue("ifsc", "");
//                           }}
//                           displayEmpty
//                         >
//                           <MenuItem value="imps">IMPS</MenuItem>
//                           <MenuItem value="upi">UPI</MenuItem>
//                         </Select>
//                         <FormHelperText>
//                           {touched.transfer_mode && errors.transfer_mode
//                             ? String(
//                                 touched.transfer_mode && errors.transfer_mode
//                               )
//                             : ""}
//                         </FormHelperText>
//                       </FormControl>
//                     </Grid>
//                   )} */}
//                   {(isOtpVerified && values.transfer_mode === "upi" && (
//                     <Grid item xs={12}>
//                       <TextField
//                         label="UPI ID"
//                         fullWidth
//                         value={values.upi_id}
//                         onChange={(e) =>
//                           setFieldValue("upi_id", e.target.value)
//                         }
//                         error={Boolean(touched.upi_id && errors.upi_id)}
//                         helperText={touched.upi_id && errors.upi_id}
//                       />
//                     </Grid>
//                   )) ||
//                     (isOtpVerified && values.transfer_mode === "imps" && (
//                       <>
//                         <Grid item xs={12}>
//                           <TextField
//                             label="Bank Account Number"
//                             fullWidth
//                             value={values.account_number}
//                             onChange={(e) =>
//                               setFieldValue("account_number", e.target.value)
//                             }
//                             error={Boolean(
//                               touched.account_number && errors.account_number
//                             )}
//                             helperText={
//                               touched.account_number && errors.account_number
//                             }
//                           />
//                         </Grid>
//                         <Grid item xs={12}>
//                           <TextField
//                             label="IFSC Code"
//                             fullWidth
//                             value={values.ifsc}
//                             onChange={(e) =>
//                               setFieldValue("ifsc", e.target.value)
//                             }
//                             error={Boolean(touched.ifsc && errors.ifsc)}
//                             helperText={touched.ifsc && errors.ifsc}
//                           />
//                         </Grid>
//                       </>
//                     ))}

//                   {/* Buttons */}
//                   <Grid item xs={12} className="mt-3">
//                     <Button
//                       type="submit"
//                       variant="contained"
//                       fullWidth
//                       disabled={loader}
//                     >
//                       {loader ? (
//                         <Spinner size="sm" />
//                       ) : isOtpVerified ? (
//                         "Submit"
//                       ) : (
//                         "Send OTP"
//                       )}
//                     </Button>
//                   </Grid>

//                   {/* <Grid item xs={12}>
//                     <Button
//                       fullWidth
//                       variant="outlined"
//                       onClick={() => navigate(-1)}
//                     >
//                       Cancel
//                     </Button>
//                   </Grid> */}
//                 </Grid>
//               </form>
//             )}
//           </SimpleCard>

//           {/* OTP MODAL */}
//           {otpModal && (
//             <VerifyInfluncer
//               mobile={values.mobile}
//               open={otpModal}
//               handleClose={() => setOtpModal(false)}
//               handleSubmit={handleOtpSuccess}
//               loading={loader}
//               setLoader={setLoader}
//             />
//           )}
//         </Grid>
//       </Grid>
//     </PageContainer>
//   );
// };

// export default RedeemCash;







import { Grid } from "@mui/material";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import { Spinner } from "react-bootstrap";
import { useParams } from "react-router-dom";
import { toast } from "react-toastify";
import * as Yup from "yup";

import { createInfluncer, redeemAmt, redirectCoupon } from "../Apis";
import { BZLogoHeader, ppwhitelogo } from "../Assets/Images";
import { decryptData } from "../Components/Helpers/encryptDecrypt";
import { validationHelper } from "../Components/Helpers/validationHelper";
import VerifyInfluncer from "../Components/StyleComponent/Modals/VerifyInfluncer";
import PageContainer from "../Components/StyleComponent/PageContainer";
import GetUserType from "../Contexts/GetUserType";

const RedeemCash = () => {
  const { id, permission_id } = useParams();

  const [loader, setLoader] = useState(false);
  const [otpModal, setOtpModal] = useState(false);
  const [isOtpVerified, setIsOtpVerified] = useState(false);
  const [success, setSuccess] = useState(false);
  const [errMsg, setErrMsg] = useState("");

  const [successDetails, setSuccessDetails] = useState({
    referenceNo: "",
    amount: "",
    dateTime: "",
  });

  const type = GetUserType();

  const validationSchema = Yup.object({
    cash: validationHelper.commonText("Cash"),

    mobile: validationHelper.commonText("Mobile"),

    upi_id: Yup.string().when("transfer_mode", {
      is: (transfer_mode: string) =>
        isOtpVerified && transfer_mode === "upi",
      then: () => validationHelper.commonText("UPI ID"),
      otherwise: () => Yup.string(),
    }),

    account_number: Yup.string().when("transfer_mode", {
      is: (transfer_mode: string) =>
        isOtpVerified && transfer_mode === "imps",
      then: () => validationHelper.commonText("Account Number"),
      otherwise: () => Yup.string(),
    }),

    ifsc: Yup.string().when("transfer_mode", {
      is: (transfer_mode: string) =>
        isOtpVerified && transfer_mode === "imps",
      then: () => validationHelper.commonText("IFSC Code"),
      otherwise: () => Yup.string(),
    }),
  });

  const formik = useFormik({
    initialValues: {
      cash: "",
      mobile: "",
      upi_id: "",
      account_number: "",
      ifsc: "",
      transfer_mode: "imps",
    },

    validationSchema,

    onSubmit: async (values) => {
      // ============================
      // SEND OTP
      // ============================
      if (!isOtpVerified) {
        setLoader(true);

        try {
          const res: any = await createInfluncer({
            mobile_number: values.mobile,
          });

          if (res.status) {
            setOtpModal(true);
          } else {
            toast.error(res.message);
          }
        } catch (err: any) {
          console.log(err);
          toast.error(err.message);
        } finally {
          setLoader(false);
        }

        return;
      }

      // ============================
      // REDEEM
      // ============================

      setLoader(true);

      const payload: any = {
        ...values,
      };

      if (type === "employee") {
        payload.permission_id = decryptData(permission_id);
      }

      payload.coupon_code = id;

      // Remove empty fields
      for (const key in payload) {
        if (payload[key] === "") {
          delete payload[key];
        }
      }

      try {
        const res: any = await redeemAmt(payload);

        if (res?.status) {
          localStorage.removeItem("accessToken");

          toast.success(res.message);

          // ========================================
          // SUCCESS DETAILS
          // ========================================

          setSuccessDetails({
            referenceNo:
              res?.data?.cf_transfer_id ||
              res?.data?.reference_number ||
              res?.data?.transaction_reference ||
              res?.reference_no ||
              res?.reference_number ||
              "—",

            amount:
              res?.data?.amount ||
              res?.data?.redeemed_amount ||
              values.cash ||
              "0",

            dateTime:
              res?.data?.date_time ||
              res?.data?.created_at ||
              new Date().toLocaleString("en-IN", {
                day: "2-digit",
                month: "short",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
                hour12: true,
              }),
          });

          setSuccess(true);
        } else {
          toast.error(res.message);
        }
      } catch (err: any) {
        toast.error(err.message);
      } finally {
        setLoader(false);
      }
    },
  });

  const {
    values,
    errors,
    touched,
    handleSubmit,
    setFieldValue,
  }: any = formik;

  // ========================================
  // GET COUPON
  // ========================================

  const getCoupon = async () => {
    await redirectCoupon({ coupon_code: id })
      .then((res: any) => {
        if (res?.status) {
          setFieldValue("cash", res?.data?.amount || "");
        } else {
          toast.error(res.message);
          setErrMsg(res.message);
        }
      })
      .catch((err) => {
        toast.error(err.message);
        setErrMsg(err.message);
      });
  };

  useEffect(() => {
    getCoupon();
  }, []);

  // ========================================
  // MOBILE CHANGE
  // ========================================

  const handleMobileChange = (e: any) => {
    const value = e.target.value;

    if (/^\d*$/.test(value) && value.length <= 10) {
      setFieldValue("mobile", value);
    }
  };

  // ========================================
  // OTP SUCCESS
  // ========================================

  const handleOtpSuccess = () => {
    setOtpModal(false);
    setIsOtpVerified(true);

    toast.success("OTP verified successfully");
  };

  // ========================================
  // FORMAT AMOUNT
  // ========================================

  const formattedAmount = Number(
    successDetails.amount || values.cash || 0
  ).toLocaleString("en-IN", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

  // ========================================
  // FORMAT DATE
  // ========================================

  const formattedDateTime = successDetails.dateTime
    ? new Date(successDetails.dateTime).toLocaleString("en-IN", {
        day: "2-digit",
        month: "short",
        year: "numeric",
        hour: "2-digit",
        minute: "2-digit",
        hour12: true,
      })
    : "—";

  return (
    <PageContainer>
      <Grid
        container
        spacing={2}
        className="d-flex justify-content-center"
      >
        <Grid item lg={7} md={9} sm={11} xs={12}>
          {success ? (
            /* ========================================
                SUCCESS SCREEN — TICKET CARD
            ======================================== */

            <div
              className="redeem-success-card"
              role="dialog"
              aria-modal="true"
              aria-labelledby="redeemTitle"
            >
              {/* HERO */}
              <div className="redeem-hero">
                <i
                  style={{
                    left: "12%",
                    width: 7,
                    height: 12,
                    background: "#ffe6a3",
                    animationDuration: "2.9s",
                    animationDelay: ".2s",
                  }}
                />
                <i
                  style={{
                    left: "33%",
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#f0e2bd",
                    animationDuration: "3.3s",
                    animationDelay: ".7s",
                  }}
                />
                <i
                  style={{
                    left: "66%",
                    width: 7,
                    height: 11,
                    background: "#fff",
                    animationDuration: "3s",
                    animationDelay: "1.1s",
                  }}
                />
                <i
                  style={{
                    left: "84%",
                    width: 6,
                    height: 6,
                    borderRadius: "50%",
                    background: "#ffe6a3",
                    animationDuration: "2.7s",
                    animationDelay: ".4s",
                  }}
                />
                <div className="redeem-hero-logo">
                  <img src={ppwhitelogo} alt="Logo" />
                </div>

                <div className="redeem-seal">
                  <span>
                    <svg
                      width="32"
                      height="32"
                      viewBox="0 0 24 24"
                      fill="none"
                      stroke="#fff"
                      strokeWidth="3.4"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    >
                      <path d="M4 12.8 9.2 18 20 6.6" />
                    </svg>
                  </span>
                </div>
              </div>

              {/* HEAD */}
              <div className="redeem-head">
                <h1 id="redeemTitle" className="mt-3">🎉 Redemption Successful!</h1>

                <p className="redeem-sub">
                  Congratulations! Your redemption request has been
                  successfully processed. ✨
                </p>

                <div>
                  <div className="redeem-amt-label">REDEEMED AMOUNT</div>

                  <div className="redeem-amt">₹ {formattedAmount}</div>
                </div>
              </div>

              {/* TICKET NOTCH */}
              <div className="redeem-stub">
                <div></div>
              </div>

              {/* BODY */}
              <div className="redeem-body">
                <div className="redeem-cap">Transaction Details</div>

                <div className="redeem-row">
                  <span className="k">🔹 Reference No.:</span>
                  <span className="v">
                    {successDetails.referenceNo || "—"}
                  </span>
                </div>

                <div className="redeem-row">
                  <span className="k">🔹 Date &amp; Time:</span>
                  <span className="v">{formattedDateTime}</span>
                </div>

                <div className="redeem-note">
                  <span>💰</span>
                  <p>
                    Your redeemed amount will be credited to your bank
                    account shortly.
                  </p>
                </div>
              </div>

              {/* FOOT */}
              <div className="redeem-foot">
                <p className="redeem-thanks">
                  Thank you for being a valued customer. ❤️
                </p>
              </div>
            </div>
          ) : (
            <div className="rf-card">
              {/* ========================================
                  HEADER
              ======================================== */}

              <div className="rf-top">
                <img
                  src={BZLogoHeader}
                  alt="logo"
                  className="rf-logo"
                />

                <h1>Bank transfer details</h1>

                <p className="rf-sub">
                  Your redeemed amount will be transferred to your
                  bank account.
                </p>

                <div className="rf-steps">
                  <span className="rf-bar on"></span>
                  <span
                    className={`rf-bar ${isOtpVerified ? "on" : ""}`}
                  ></span>
                  <span className="rf-bar"></span>
                  <b>Step {isOtpVerified ? 2 : 1}</b> of 3
                </div>
              </div>

              {errMsg ? (
                /* ========================================
                    ERROR
                ======================================== */

                <div
                  className="alert alert-danger text-center m-3"
                  role="alert"
                >
                  {errMsg}
                </div>
              ) : (
                /* ========================================
                    REDEMPTION FORM
                ======================================== */

                <form
                  onSubmit={handleSubmit}
                  className="rf-form"
                >
                  {/* CASH */}
                  {/* <div>
                    <label className="rf-label">Cash</label>

                    <div className="rf-field rf-field--locked">
                      <span className="rf-pre">₹</span>
                      <input
                        className="locked"
                        value={values.cash}
                        readOnly
                      />
                    </div>
                  </div> */}

                  {/* MOBILE */}
                  <div>
                    <label className="rf-label">Mobile Number</label>

                    <div
                      className={`rf-field ${
                        isOtpVerified ? "rf-field--locked" : ""
                      } ${
                        touched.mobile && errors.mobile ? "bad" : ""
                      }`}
                    >
                      <span className="rf-pre">+91</span>
                      <input
                        inputMode="numeric"
                        placeholder="10-digit mobile number"
                        value={values.mobile}
                        onChange={handleMobileChange}
                        readOnly={isOtpVerified}
                        className={isOtpVerified ? "locked" : ""}
                      />
                    </div>

                    {touched.mobile && errors.mobile && (
                      <p className="rf-msg">⚠ {errors.mobile}</p>
                    )}
                  </div>

                  {/* ========================================
                      TRANSFER MODE — always IMPS, hidden

                  {isOtpVerified && (
                    <div>
                      <label className="rf-label">
                        Transfer Mode <i>*</i>
                      </label>

                      <div className="rf-field sel">
                        <select
                          value={values.transfer_mode}
                          onChange={(e) => {
                            setFieldValue(
                              "transfer_mode",
                              e.target.value
                            );
                            setFieldValue("upi_id", "");
                            setFieldValue("account_number", "");
                            setFieldValue("ifsc", "");
                          }}
                        >
                          <option value="imps">IMPS</option>
                          <option value="upi">UPI</option>
                        </select>
                      </div>
                    </div>
                  )}
                  ======================================== */}

                  {/* ========================================
                      BANK DETAILS (IMPS)
                  ======================================== */}

                  {isOtpVerified && (
                    <>
                      {/* BANK ACCOUNT NUMBER */}
                      <div>
                        <label className="rf-label">
                          Bank Account Number <i>*</i>
                        </label>

                        <div
                          className={`rf-field ps-3 ${
                            touched.account_number &&
                            errors.account_number
                              ? "bad"
                              : ""
                          }`}
                        >
                          <input
                            inputMode="numeric"
                            placeholder="e.g. 5021 4478 9012"
                            value={values.account_number}
                            onChange={(e) =>
                              setFieldValue(
                                "account_number",
                                e.target.value
                              )
                            }
                          />
                        </div>

                        {touched.account_number &&
                          errors.account_number && (
                            <p className="rf-msg">
                              ⚠ {errors.account_number}
                            </p>
                          )}
                      </div>

                      {/* IFSC CODE */}
                      <div>
                        <label className="rf-label">
                          IFSC Code <i>*</i>
                        </label>

                        <div
                          className={`rf-field ps-3 ${
                            touched.ifsc && errors.ifsc
                              ? "bad"
                              : ""
                          }`}
                        >
                          <input
                            placeholder="e.g. HDFC0001234"
                            style={{ textTransform: "uppercase" }}
                            value={values.ifsc}
                            onChange={(e) =>
                              setFieldValue(
                                "ifsc",
                                e.target.value.toUpperCase()
                              )
                            }
                          />
                        </div>

                        {touched.ifsc && errors.ifsc ? (
                          <p className="rf-msg">⚠ {errors.ifsc}</p>
                        ) : (
                          <p className="rf-hint">
                            11 characters — found on your bank
                            passbook or cheque.
                          </p>
                        )}
                      </div>
                    </>
                  )}

                  {/* ========================================
                      SUBMIT
                  ======================================== */}

                  <button
                    className="rf-cta"
                    type="submit"
                    disabled={loader}
                  >
                    {loader ? (
                      <Spinner size="sm" />
                    ) : (
                      <>
                        {isOtpVerified ? "Submit" : "Send OTP"}
                        <span aria-hidden="true">→</span>
                      </>
                    )}
                  </button>

                  <div className="rf-foot">
                    <span className="rf-dot"></span>
                    Details are encrypted and used only for this
                    transfer
                  </div>
                </form>
              )}

              {/* ========================================
                  OTP MODAL
              ======================================== */}

              {otpModal && (
                <VerifyInfluncer
                  mobile={values.mobile}
                  open={otpModal}
                  handleClose={() => setOtpModal(false)}
                  handleSubmit={handleOtpSuccess}
                  loading={loader}
                  setLoader={setLoader}
                />
              )}
            </div>
          )}
        </Grid>
      </Grid>
    </PageContainer>
  );
};

export default RedeemCash;